import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import { IAppFeatures } from './IAppFeatures';
import { SERVER_ENDPOINT } from './websocket.token';

const DEFAULT_FEATURE_SETTINGS: IAppFeatures = {
	race: {
		disableStream: false,
	},
	notificationMessage: '',
};

@Injectable({
	providedIn: 'root',
})
export class FeatureSettingsService {
	private readonly http = inject(HttpClient);
	private readonly featureSettingsSubject = new BehaviorSubject<IAppFeatures>(
		DEFAULT_FEATURE_SETTINGS,
	);

	public readonly featureSettings$ = this.featureSettingsSubject.asObservable();

	constructor(@Inject(SERVER_ENDPOINT) private readonly serverEndpoint: string) { }

	public getFeatureSettings(): Observable<IAppFeatures> {
		return this.fetchFeatureSettings();
	}

	public fetchFeatureSettings(): Observable<IAppFeatures> {
		return this.http.get<IAppFeatures>(`${this.serverEndpoint}api/features-settings`);
	}

	public loadFeatureSettings(): Observable<IAppFeatures> {
		return this.fetchFeatureSettings().pipe(
			tap((settings) => {
				this.updateFeatureSettings(settings);
			}),
		);
	}

	public updateFeatureSettings(settings: Partial<IAppFeatures>): void {
		this.featureSettingsSubject.next({
			...this.featureSettingsSubject.value,
			...settings,
			race: {
				...this.featureSettingsSubject.value.race,
				...settings?.race,
			},
		});
	}

	public getCurrentFeatureSettings(): IAppFeatures {
		return this.featureSettingsSubject.value;
	}
}
